import { render, staticRenderFns } from "./CaseDetailsModal.vue?vue&type=template&id=73cfceb0&"
import script from "./CaseDetailsModal.vue?vue&type=script&lang=js&"
export * from "./CaseDetailsModal.vue?vue&type=script&lang=js&"
import style0 from "./CaseDetailsModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports